export const ExportExternalDocumentPacketDocumentation = `
# Export an external document packet to Customer

Securely transfers external document packets from the Notable secure storage to a customer organization's SFTP folder.

When the Export Path is provided, the document will be exported to the following location on the SFTP:

\`\`\`
<organization-name>/<EXPORT_PATH>/<DOCUMENT_NAME>
\`\`\`

### Input
 - **ExternalDocumentPacket**: Select a block provides an ExternalDocumentPacket entity.
 - **Export Reason**: Select the reason you are exporting the document; will determine the destination folder.
 - **Export Path**: Relative path to export the document to. If not provided, default path based on export reason will be used.
`;
